module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/011-zimbabwe-220a561213c7b26cf93a127d76ea1340.svg";